import {reduceRelayPaginationAction, RelayPaginationActionPayload, RelayPaginationState} from "providerapp/pagination";
import {DEFAULT_PAGE_SIZE} from "../../const";
import {SortOrder} from "../domain";
import {SubmittedRequestInfo, SubmittedRequestSortBy, SubmittedRequestType} from "./SubmittedRequestDomain";

export type SubmittedRequestListFilterValue = {
    status?: string | null;
    requestType?: string | null;
    submittedDateFrom?: Date | null;
    submittedDateTo?: Date | null;
    closedDateFrom?: Date | null;
    closedDateTo?: Date | null;
    submittedBy?: string | null;
    clientGuid?: string | null;
};

export type SubmittedRequestListAction =
    | { type: 'SET_SELECTED'; selected: SubmittedRequestInfo | null }
    | { type: 'SET_SORT_BY'; sortBy: SubmittedRequestSortBy }
    | { type: 'SET_SEARCH'; search: string }
    | { type: 'SET_FILTER'; filter: SubmittedRequestListFilterValue }
    | { type: 'SET_PAGE_SIZE'; pageSize: number }
    | RelayPaginationActionPayload;

export interface SubmittedRequestListState {
    pagination: RelayPaginationState;
    sortBy: SubmittedRequestSortBy;
    filter: SubmittedRequestListFilterValue;
    selected: any | null;
    search: string;
    pageSize: number;
}

export function initState(): SubmittedRequestListState {
    const defaultPagination = new RelayPaginationState('0', DEFAULT_PAGE_SIZE);
    return {
        pagination: defaultPagination,
        pageSize: defaultPagination.size,
        selected: null,
        search: "",
        filter: {
            status: "Active; In Progress; Information Needed; New; Pending; Pending Approval",
            requestType: null,
            submittedDateFrom: null,
            submittedDateTo: null,
            closedDateFrom: null,
            closedDateTo: null,
            submittedBy: null,
        },
        sortBy: {
            column: "caseNumber",
            order: SortOrder.DESC
        },
    };
}

export function submittedRequestListReducer(
    state: SubmittedRequestListState,
    action: SubmittedRequestListAction
): SubmittedRequestListState {
    switch (action.type) {
        case 'SET_SELECTED':
            return {
                ...state,
                selected: action.selected
            };
            
        case 'RELAY_PAGINATION_ACTION':
            return {
                ...state,
                pagination: reduceRelayPaginationAction(state.pagination, action)
            };
            
        case 'SET_SORT_BY':
            return {
                ...state,
                sortBy: action.sortBy
            };
            
        case 'SET_SEARCH':
            return {
                ...state,
                search: action.search,
                pagination: new RelayPaginationState('0', state.pageSize),
            };
            
        case 'SET_FILTER':
            return {
                ...state,
                filter: action.filter,
                pagination: new RelayPaginationState('0', state.pageSize),
            };
            
        case 'SET_PAGE_SIZE':
            return {
                ...state,
                pageSize: action.pageSize,
                pagination: new RelayPaginationState('0', action.pageSize),
            };
            
        default:
            return state;
    }
}
